import { render, staticRenderFns } from "./detail-component-linear-section.vue?vue&type=template&id=48d12662&scoped=true"
import script from "./detail-component-linear-section.vue?vue&type=script&lang=ts"
export * from "./detail-component-linear-section.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d12662",
  null
  
)

export default component.exports